import { Badge } from "@/design-system/components/ui";
import type { KbDocumentStatus } from "@/api/knowledgeBase";

// Knowledge Base v1.0 PR 4 — single-source mapping from KbDocumentStatus
// to a Badge status. Indexed maps to "finalized" (gold/success), Processing
// to "review" (warning), Draft to "draft", Failed to "error", Retired to
// "archived".

const STATUS_MAP: Record<
  KbDocumentStatus,
  { status: "draft" | "review" | "finalized" | "error" | "archived"; label: string }
> = {
  Draft: { status: "draft", label: "Draft" },
  Processing: { status: "review", label: "Processing" },
  Indexed: { status: "finalized", label: "Indexed" },
  Failed: { status: "error", label: "Failed" },
  Retired: { status: "archived", label: "Retired" },
};

interface KbStatusBadgeProps {
  status: KbDocumentStatus;
  title?: string;
}

export function KbStatusBadge({ status, title }: KbStatusBadgeProps) {
  const cfg = STATUS_MAP[status];
  return (
    <Badge status={cfg.status} title={title}>
      {cfg.label}
    </Badge>
  );
}
